var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcondots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 16,
    viewBox: "0 0 4 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.99935 8.83398C2.45959 8.83398 2.83268 8.46089 2.83268 8.00065C2.83268 7.54041 2.45959 7.16732 1.99935 7.16732C1.53911 7.16732 1.16602 7.54041 1.16602 8.00065C1.16602 8.46089 1.53911 8.83398 1.99935 8.83398Z",
    stroke: "#344054",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99935 3.00065C2.45959 3.00065 2.83268 2.62755 2.83268 2.16732C2.83268 1.70708 2.45959 1.33398 1.99935 1.33398C1.53911 1.33398 1.16602 1.70708 1.16602 2.16732C1.16602 2.62755 1.53911 3.00065 1.99935 3.00065Z",
    stroke: "#344054",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99935 14.6673C2.45959 14.6673 2.83268 14.2942 2.83268 13.834C2.83268 13.3737 2.45959 13.0007 1.99935 13.0007C1.53911 13.0007 1.16602 13.3737 1.16602 13.834C1.16602 14.2942 1.53911 14.6673 1.99935 14.6673Z",
    stroke: "#344054",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcondots);
export default __webpack_public_path__ + "static/media/Icondots.6dc2ad1d5cb785aeca98b5baafdaaecf.svg";
export { ForwardRef as ReactComponent };